require('./cardLastMovementsFilter.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const moment = require('moment');

//@utilities
const { getLanguage } = require('core/i18n').i18n;
const {formatCurrency} = require('utilities/currencyHelper');

// @commons
const DateFilter = require('components/commons/dateFilter/dateFilter');

// @components
const CardStateFilter = require('components/cards/cardStateFilter/cardStateFilter');
const CardSituationFilter = require('components/cards/cardSituationFilter/cardSituationFilter');
const OKModal = require('components/commons/OKModal/OKModal');
import { OKInput } from 'commonsComponents/OKInput';
const { AmountFilter } = require('commonsComponents/amountFilter');

// @constants
const { CARD_CREDIT, DATE_FILTER_NONE } = require('constants/index');
const DEFAULT_CARD_TRANSACTION_FROM = 6;
const DEFAULT_CARD_TRANSACTION_FROM_UNIT = 'months';
const { AMOUNT_FILTER_LABEL, AMOUNT_FILTER_GREATER_THAN, AMOUNT_FILTER_LOWER_THAN } = require('constants/commonsComponents');
const { NOT_ALLOWED_CARDS_SEARCH_BY_TEXT_FILTERS_COUNTRIES, NOT_ALLOWED_CARDS_SEARCH_BY_AMOUNT_FILTERS_COUNTRIES } = require('constants/flagBasedFeatures');
const { EURO_TEXT } = require('constants/index');

//@core
const { formatText } = require('core/i18n').i18n;


class CardLastMovementsFilter extends React.Component {
    constructor(props) {
        super(props);

        const { immFilters } = props;

        this.state = {
            dateFrom: immFilters.getIn(['date','from']),
            dateSelected: immFilters.getIn(['date','selected']),
            dateTo: immFilters.getIn(['date','to']),
            situationSelected: immFilters.getIn(['situation', 'selected']),
            stateSelected: immFilters.getIn(['state', 'selected']),
            amountFrom: immFilters.getIn(['amount','from','amount']),
            amountTo: immFilters.getIn(['amount','to','amount']),
            newTextFilterValue:immFilters.getIn(['description', 'selected'])
        };

        this.handleChangeDateMin = this.handleChangeDateMin.bind(this);
        this.handleChangeDateMax = this.handleChangeDateMax.bind(this);
        this.handleChangeDateSelected = this.handleChangeDateSelected.bind(this);
        this.handleChangeSituationSelected = this.handleChangeSituationSelected.bind(this);
        this.handleChangeStateSelected = this.handleChangeStateSelected.bind(this);
        this.handleOnSubmit = this.handleOnSubmit.bind(this);
        this.handleChangeAmountMin = this.handleChangeAmountMin.bind(this);
        this.handleChangeAmountMax = this.handleChangeAmountMax.bind(this);
        this.handleNewTextFilter=this.handleNewTextFilter.bind(this);

    }
    handleInstructionMessage(textFilterValue){
        const charsLeft = 100 - textFilterValue.length;
        const message = formatText('transfers-charactersLeft', [charsLeft]);
        return message;
    }

    handleNewTextFilter(event) {
        this.setState({newTextFilterValue:event.target.value});
    }

    handleChangeDateMax(dateTo) {
        this.setState({
            dateTo
        });
    }
    handleChangeAmountMax(amountTo) {
        this.setState({
            amountTo
        });
    }

    handleChangeAmountMin(amountFrom) {
        this.setState({
            amountFrom
        });
    }
    handleChangeDateMin(dateFrom) {
        this.setState({
            dateFrom
        });
    }

    handleChangeDateSelected(dateSelected) {
        this.setState({
            dateSelected
        });
    }

    handleChangeStateSelected(stateSelected) {
        this.setState({
            stateSelected
        });
    }

    handleChangeSituationSelected(situationSelected) {
        this.setState({
            situationSelected
        });
    }

    handleOnSubmit() {
        const { dateSelected, dateFrom, cardCurrency, dateTo, situationSelected, stateSelected,newTextFilterValue,amountFrom,amountTo } = this.state;

        this.props.setFilters({
            date: {
                isActive: dateSelected !== DATE_FILTER_NONE,
                selected: dateSelected,
                from: dateFrom,
                to: dateTo
            },
            situation: {
                isActive: !!situationSelected,
                selected: situationSelected
            },
            state: {
                isActive: !!stateSelected,
                selected: stateSelected
            },
            description:{
                isActive: !!newTextFilterValue,
                selected: newTextFilterValue
            },
            amount:{
                isActive:  !!amountTo || !!amountFrom,
                from: {
                    amount: amountFrom,
                    currency: cardCurrency || EURO_TEXT
                },
                to: {
                    amount: amountTo,
                    currency: cardCurrency || EURO_TEXT
                }
              
            }
        });
    }

    buildCreditCardFilters() {
        const { showStateFilter, immCard, immFilters } = this.props;
        let filter;

        if (immCard.get('type') === CARD_CREDIT && !immCard.get('isViaT') && showStateFilter) {
            filter = (
                <CardStateFilter
                    immFilter={immFilters.get('state')}
                    last={true}
                    onChangeSelected={this.handleChangeStateSelected}
                />
            );
        }

        return filter;
    }

    render() {
        const { onCloseClick, immFilters , flagBasedFeatures, cardCurrency, minDateFilterAllowed } = this.props;
        const minDateAllowed = minDateFilterAllowed ? minDateFilterAllowed : DEFAULT_CARD_TRANSACTION_FROM; 
        const cardsMinDateAllowed = moment().startOf('day').subtract(minDateAllowed, DEFAULT_CARD_TRANSACTION_FROM_UNIT);
        const creditCardFilters = this.buildCreditCardFilters();
        const { amountFrom, amountTo ,newTextFilterValue} = this.state;
        const allowedTextFiltersCountries = flagBasedFeatures.get(NOT_ALLOWED_CARDS_SEARCH_BY_TEXT_FILTERS_COUNTRIES);
        const allowedAmountFiltersCountries = flagBasedFeatures.get(NOT_ALLOWED_CARDS_SEARCH_BY_AMOUNT_FILTERS_COUNTRIES);

        const content = (
            <React.Fragment>
                <div className="card-last-movements-filter__date-filter-wrapper">
                {allowedTextFiltersCountries && 
                   <OKInput   
                        onChange={this.handleNewTextFilter}
                        placeholder={formatText('myMoneyTransactions-textFilterPlaceholder')}
                        value={newTextFilterValue}
                        maxLength="100"
                        instructionsMessage={this.handleInstructionMessage(newTextFilterValue)}
                    />} 
                    <DateFilter
                        immFilter={immFilters.get('date')}
                        onChangeMin={this.handleChangeDateMin}
                        onChangeMax={this.handleChangeDateMax}
                        onChangeSelected={this.handleChangeDateSelected}
                        minDate={cardsMinDateAllowed}
                        showAnnual={true}
                    />
                </div>
             
                <CardSituationFilter
                    immFilter={immFilters.get('situation')}
                    onChangeSelected={this.handleChangeSituationSelected}
                />
                {creditCardFilters}
                {allowedAmountFiltersCountries &&   
                   <AmountFilter
                    immFilter={immFilters}
                    onChangeMin={this.handleChangeAmountMin}
                    onChangeMax={this.handleChangeAmountMax}
                    fromValue={amountFrom}
                    toValue={amountTo}
                    currencySymbol={formatCurrency(cardCurrency)}
                    amountLabel={AMOUNT_FILTER_LABEL}
                    greaterThan={AMOUNT_FILTER_GREATER_THAN}
                    lowerThan={AMOUNT_FILTER_LOWER_THAN}
                    language={getLanguage()}
                />}
            </React.Fragment>
        );

        return (
            <OKModal
                isOpen={true}
                content={content}
                onCloseCallback={onCloseClick}
                footerType="navigation"
                onPrimaryButtonClick={this.handleOnSubmit}
                onSecondaryButtonClick={onCloseClick}
                primaryButtonText="filterDate-apply"
                secondaryButtonText="filterDate-cancel"
                title="cards-filterMovements"
            />
        );
    }
}

CardLastMovementsFilter.defaultProps = {
    showStateFilter: true,
    cardCurrency: EURO_TEXT
};

CardLastMovementsFilter.propTypes = {
    showStateFilter: PropTypes.bool,
    immCard: PropTypes.object.isRequired,
    immFilters: PropTypes.object.isRequired,
    onCloseClick: PropTypes.func.isRequired,
    setFilters: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object,
    cardCurrency: PropTypes.string.isRequired,

};

module.exports = CardLastMovementsFilter;